module.exports = __webpack_public_path__ + "img/AC_S2_Calendar.bd444234.jpg";